/**
 * Sorting Helpers for Rate Review Module
 * @module RateReviewSortingHelpers
 */

/**
 * Sorts leads by date created column
 * @param {Array} leads - Array of lead objects to sort
 * @param {string} direction - Sort direction ('asc' for ascending, 'desc' for descending)
 * @returns {Array} New sorted array of leads
 */
export const sortLeadsByDateCreated = (leads, direction = 'asc') => {
  return [...leads].sort((a, b) => {
    const aValue = a.dateCreated || (a.Created_Time?.split("T")[0]) || "";
    const bValue = b.dateCreated || (b.Created_Time?.split("T")[0]) || "";

    if (!aValue && !bValue) return 0;
    if (!aValue) return 1;
    if (!bValue) return -1;

    return direction === 'asc'
      ? aValue.localeCompare(bValue)
      : bValue.localeCompare(aValue);
  });
};

/**
 * Gets next sort direction based on current state
 * @param {number|null} currentColumn - Current sorted column index
 * @param {number} targetColumn - Target column index to sort
 * @param {string|null} currentDirection - Current sort direction
 * @returns {string|null} Next sort direction
 */
export const getNextSortDirection = (currentColumn, targetColumn, currentDirection) => {
  if (currentColumn !== targetColumn) {
    return 'asc';
  }

  if (currentDirection === 'asc') {
    return 'desc';
  }

  if (currentDirection === 'desc') {
    return null;
  }

  return 'asc';
};

